import { render, staticRenderFns } from "./CreateDatasetDialog.vue?vue&type=template&id=1257c7f8"
import script from "./CreateDatasetDialog.vue?vue&type=script&lang=js"
export * from "./CreateDatasetDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports